<template>
	<b-overlay :show="loading" rounded="lg" spinner-variant="customer">
		<b-row no-gutters :style="{ backgroundSize: 'cover', backgroundImage: 'url('+background+')'}" class="vh-100" >
			<b-col lg="5" :style="{ background: color }">
				<div style="height: 100%" class="d-flex flex-wrap">
					<div class="text-right d-block w-100">
						<div class="text-center pt-5">
							<b-link :href="$store.state.customer_link">
								<img class='login-logo pt-5' :src="logo">
							</b-link>å
						</div>
					</div>
					<div  class="d-flex align-content-center flex-wrap w-100">
						<b-row no-gutters>
							<b-col>
								<h1 class="text-center text-white login-text">Hola!</h1>
								<h4 class="text-center text-white login-text px-3">Te invitamos a la sala de ventas virtual de Inmobiliaria Argenta.</h4>
								<div class="px-5 mx-5 my-5">
									<b-alert variant="danger" :show="error.length > 0" dismissible>{{error}}</b-alert>
									<label class="text-white">RUT <small v-if="chilean">Por favor ingresar sin puntos y con guión</small></label>
									<input id="rut" @keyup="formatRut" v-model="rut" placeholder="Ingrese RUT" class="form-control btn-squared">
									<label class="text-white mt-3">Contraseña</label>
									<input placeholder="Ingrese contraseña"	id="password" class="form-control btn-squared" :type="passwordFieldType" @input="password = $event.target.value" autocomplete="off">
									<br>
									<b-button squared variant="customer" block class="mt-3" @click="login()">ENTRAR</b-button>
								</div>
							</b-col>
						</b-row>
					</div>
				</div>
			</b-col>
		</b-row>
	</b-overlay>
</template>
<script>
export	default	{
	name:	"login",
	data()	{
		return	{
			logo: require("@/assets/images/customer/"+this.$store.state.customer+"/logo.png"),
			background: require("@/assets/images/customer/"+this.$store.state.customer+"/login-bg.jpg"),
			color: 'rgba(22,22,22,.83)',
			image: '',
			rut: "",
			error: "",
			password: "",
			loading: false,
			chilean: true,
			passwordFieldType: 'password',
		};
	},
	mounted()	{
		//this.get_info_customer()
	},
	methods: {
		get_info_customer() {
			let cur = this;
			this.axios.get("clients/info/" + this.$store.state.customer_id).then(result => {
				if (result.data.logo_1_url.length > 0)
					cur.logo = 'http:'+ result.data.logo_1_url
					cur.color = result.data.color_2
			}).catch(error => {
				console.log(error)
			});
		},
		login()	{
			let	app = this;
			app.loading = true;
			app.error = "";
			app.$auth.login({data: { email: this.rut, password: this.password, customer_id: this.$store.state.customer_id, error: null
				},
				success: function (msg) {
					app.loading = false;
					app.error = "";
					app.$auth.user(msg.data.user);
				},
				error: function () {
					app.loading = false;
					this.error = "RUT y/o Contraseña inválidos";
				},
				rememberMe: true,
				redirect: '/',
				fetchUser: true,
			});
		},
		goTo(link, data = null) {
			this.$router.push({ name: link, params: data });
		},
		switchVisibility(){
			this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
		},
			digito(rut, dv) {
				let suma = 0;
				let multiplicador = 2;
				while (rut !== 0) {
					if (multiplicador === 8) {
						multiplicador = 2;
					}
					suma += (rut % 10) * multiplicador;
					rut = Math.trunc(rut / 10);
					multiplicador++;
				}
				suma = 11 - (suma % 11);
				switch (suma) {
					case 11:
						return ("0" === dv);
					case 10:
						return ("K" === dv.toUpperCase());
					default:
						return (suma.toString() === dv);
				}
			},
			formatRut(){
				if(this.chilean){
					if(this.rut.length > 0){
						this.rut = this.rut.replace(/[^\dKk]/g, '');
						let dato = this.rut;
						let largo = dato.length;
						if (largo === 1) {
							this.dv = dato;
							this.rut = '';
							this.digito(this.rut, this.dv);
							this.formato()
						} else if (largo > 1) {
							this.dv = dato.substring(largo - 1);
							this.rut = dato.substring(largo - 1, 0);
							this.digito(this.rut, this.dv);
							this.formato()
						}
					}
				}else{
					return true
				}
			},
			formato() {
				let rut = (this.rut) ? (parseInt(this.rut)) + '-' : '';
				this.rut = rut + this.dv;
			},
	}
};
</script>
<style>
	.container-login {
		height: 100vh;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.content-login {
		width: auto;
		height: auto;
	}
	.content-login .btn {
		width: 100%;
	}
	.login-text{
		text-transform: uppercase;
	}
	.login-logo {
		top: 1.6em;
		width: 10em;
	}
	.text-white {
		color: white !important;
	}
</style>